import React, { useEffect, useState } from "react"
import {
  Typography,
  Card,
  CardHeader,
  Avatar,
  CardMedia,
  CardContent,
  CardActions,
  Button,
  IconButton,
  Tooltip,
  Grow,
  Box
} from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import ErrorRoundedIcon from "@material-ui/icons/ErrorRounded"
import cloudinary from "cloudinary-core"
import TrashIcon from "@material-ui/icons/Delete"
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled"
import noPostsImg from "assets/no-posts-img.svg"

const cl = new cloudinary.Cloudinary({
  cloud_name: process.env.REACT_APP_CLOUD_NAME
})

const PostCard = ({ classes, children, post, handleRemove, handlePublish }) => {
  const {
    id,
    created,
    first_name: firstName,
    last_name: lastName,
    profile_image: profileImage,
    image,
    posted,
    title_value: titleValue,
    originally_posted: originallyPostedName,
    originally_posted_logo: originallyPostedLogo
  } = post
  // const imageObj = JSON.parse(image)

  const [uploadType, setUploadType] = useState(null)
  const [source, setSource] = useState(null)
  const [downloadSource, setDownloadSource] = useState(null)
  // console.log(uploadType)
  // console.log({ source })
  // Caclulates days until post expires
  const timeLeft = () => {
    const dateCreated = new Date(created)
    const now = new Date()
    const hours = Math.abs(now - dateCreated) / 36e5
    const timeLeft = posted
      ? 366 - Math.ceil(hours / 24)
      : 8 - Math.ceil(hours / 24)
    let expiresDisplay

    switch (true) {
      case timeLeft > 1:
        expiresDisplay = `${timeLeft} days`
        break
      case timeLeft === 1:
        expiresDisplay = `${timeLeft} day`
        break
      case timeLeft < 1:
        expiresDisplay = `Today`
        break
    }

    return expiresDisplay
  }

  useEffect(() => {
    const fileObj = image && JSON.parse(image)
    setUploadType(fileObj.resource_type)
    if (fileObj.resource_type === "video") {
      setSource(
        cl.video_url(`${fileObj.public_id}.jpg`, {
          startOffset: "1"
        })
      )
      setDownloadSource(cl.video_url(`${fileObj.public_id}`, {}))
    } else {
      setSource(
        cl.url(fileObj.public_id, {
          width: 600,
          height: 600,
          crop: "fill",
          gravity: "auto",
          flags: "attachment"
        })
      )
      setDownloadSource(cl.url(fileObj.public_id, { flags: "attachment" }))
    }
  }, [image])

  let title
  let subTitle
  let avatar
  if (originallyPostedName) {
    title = originallyPostedName
    subTitle = `${firstName} ${lastName}`
    avatar = originallyPostedLogo
  } else {
    title = `${firstName} ${lastName}`
    subTitle = titleValue && titleValue
    avatar = profileImage
  }

  return (
    <Grow in timeout={500} style={{ transformOrigin: "50% 50%" }}>
      <Card className={classes.root}>
        <CardHeader
          avatar={
            <Avatar
              aria-label="post"
              className={classes.avatar}
              src={
                avatar &&
                cl.url(JSON.parse(avatar).public_id, {
                  width: 200,
                  crop: "scale"
                })
              }
            >
              {firstName ? firstName.split("").splice(0, 1) : ""}
              {lastName ? lastName.split("").splice(0, 1) : ""}{" "}
            </Avatar>
          }
          title={title}
          subheader={subTitle}
          titleTypographyProps={{
            className: classes.title
          }}
          subheaderTypographyProps={{
            className: classes.subheader
          }}
          action={
            <Tooltip title="Remove">
              {/* <a href={source} target="_blank"> */}
              <IconButton
                onClick={() => handleRemove(id)}
                className={classes.removeButton}
                aria-label="remove"
              >
                <TrashIcon />
              </IconButton>
            </Tooltip>
          }
        />
        {uploadType && (
          <CardMedia
            // className={uploadType === "image" ? classes.image : classes.video}
            className={classes.cardMedia}
            // component={uploadType === "video" ? "video" : "img"}
            component={"div"}
            controls={uploadType === "video"}
            // src={source}
            // title=""
            // preload="metadata"
            // playsInline="playsinline"
          >
            <img
              className={classes.image}
              src={source ? source : noPostsImg}
              alt="Post"
              onError={e => (e.target.src = noPostsImg)}
            />
            {uploadType === "video" && (
              <Box className={classes.iconContainer}>
                <PlayCircleFilledIcon className={classes.playIcon} />
              </Box>
            )}
          </CardMedia>
        )}
        <CardContent>
          <Typography variant="body1" color="textSecondary" component="p">
            {children}
          </Typography>
        </CardContent>
        <CardActions className={classes.cardAction}>
          <div className={classes.expires}>
            <Typography className={classes.expiresContent}>
              expires{" "}
              {timeLeft <= 3 && (
                <ErrorRoundedIcon className={classes.errorIcon} />
              )}
            </Typography>
            <Typography variant="h3" className={classes.expiresDisplayText}>
              {timeLeft()}
            </Typography>
          </div>
          <div className={classes.actionButtons}>
            <Button
              variant="contained"
              className={classes.downloadButton}
              onClick={() => window.open(downloadSource, "_blank")}
            >
              Download
            </Button>
            <Button
              variant="contained"
              className={classes.publishButton}
              onClick={() => handlePublish(id)}
              disabled={Boolean(posted)}
            >
              {posted ? "Published" : "Publish"}
            </Button>
          </div>
        </CardActions>
      </Card>
    </Grow>
  )
}

export default withStyles(styles)(PostCard)



// WEBPACK FOOTER //
// ./src/components/PostCard/index.jsx